import React from 'react'
import i18n from '../i18n';

const TopBar = () => {

  const handleChange = (lang) => {
    localStorage.setItem("lang", lang)
    i18n.changeLanguage(lang);
  }


  return (
    <section id="topbar" className="d-flex align-items-center">
      <div className="container d-flex justify-content-center justify-content-md-between">
        <div className="contact-info d-flex align-items-center">
          <i className="bi bi-envelope d-flex align-items-center"><a href="mailto:sales@kasabkablo.com">sales@kasabkablo.com</a></i>
          <i className="bi bi-phone d-flex align-items-center ms-4"><span><a href='tel:+905312881322'>+90 531 288 13 22</a></span></i>
        </div>
        <div style={{ display: "flex", gap: ".5rem" }}>
          <div className="social-links d-none d-md-flex align-items-center">
            <a href="https://www.facebook.com/Kasab-Kablo-115338877004429" className="facebook"><i className="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/kasabkablo99/" className="instagram"><i className="bi bi-instagram"></i></a>
            <a href="https://tr.linkedin.com/company/kasab-kablo-elektri%CC%87k-san-ve-ti%CC%87c-ltd-%C5%9Fti%CC%87" className="linkedin"><i className="bi bi-linkedin"></i></a>
          </div>
          <div>
            <select style={{ padding: ".1rem .25rem", marginLeft: ".25rem" }} value={i18n.language} onChange={(e) => handleChange(e.target.value)}>
              <option value='en'>EN</option>
              <option value='tr'>TR</option>
            </select>
          </div>
        </div>
      </div>
    </section >
  );
}

export default TopBar;
